// extracted by mini-css-extract-plugin
export default {"container":"IntroHeader_container__5tG0t","title":"IntroHeader_title__E3cMi","tag":"IntroHeader_tag__Gco3l"};